import { describeWorkspace, loadAuth } from '../project/auth'
import { deployCommand } from './commands/deploy'
import { say } from './output'
import { confirm } from './prompts/confirm'

// A scaffolded service does nothing until it is deployed, and the console shows nothing until then either.
// Offering the next step is the difference between a command that finished and a workflow that got somewhere.

/**
 * Offer to deploy the service that was just scaffolded, and do it if the answer is yes.
 * Returns whether the deploy ran.
 *
 * Only that one service goes up. A deploy is per-service now, so sending the whole project would touch
 * siblings the user did not just create and did not ask about.
 *
 * Yes is the default even when a login is still needed: someone who has just scaffolded a service is trying
 * to get it into their workspace, and the connection is a step on that path rather than a separate decision.
 * The question names the workspace when the project already has one, so nobody deploys to a workspace they
 * forgot they were connected to.
 */
export async function offerDeploy(serviceId: string): Promise<boolean> {
  if (!process.stdin.isTTY) {
    return false
  }

  const stored = loadAuth()
  // Short form: the question is already long, and the id is stated in full when the connection is made.
  const where = stored?.workspaceId
    ? `the workspace ${ describeWorkspace(stored, { short: true }) }`
    : 'your Flowrunner workspace'

  if (!await confirm(`\nWould you like to deploy "${ serviceId }" to ${ where }?`, true)) {
    return false
  }

  say('')

  await deployCommand({ service: [serviceId] })

  return true
}
